import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import Alert from '../components/Alert';
import Link from '../components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const PrivateBetaAvailable = () => {
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "developer-docs-mdx-components.staticAlerts.privateBeta_jsx",
      elements: {
        Link
      },
      options: {
        href: 'https://community.hubspot.com/t5/Product-Betas/ct-p/product-betas'
      }
    })
  });
};
const NewVersionUnderDevelopment = () => {
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "developer-docs-mdx-components.staticAlerts.newVersionUnderDevelopment_jsx",
      elements: {
        Link
      },
      options: {
        href: 'https://developers.hubspot.com/changelog'
      }
    })
  });
};
const PublicBeta = () => {
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "developer-docs-mdx-components.staticAlerts.publicBetaAlert_jsx",
      elements: {
        Link
      },
      options: {
        developerTermsHref: 'https://legal.hubspot.com/developer-terms',
        developerBetaTermsHref: 'https://legal.hubspot.com/developerbetaterms?'
      }
    })
  });
};
export { PrivateBetaAvailable, NewVersionUnderDevelopment, PublicBeta };